import type { FieldError } from 'react-hook-form';

export const SIGNUP_EMAIL_MUST_BE_UNIQUE = 'emailMustBeUnique';

// The email existence provider could not find the mailbox (or it is disposable).
export const SIGNUP_EMAIL_MUST_EXIST = 'emailMustExist';

export const isEmailUniquenessError = (error?: FieldError) => error?.type === SIGNUP_EMAIL_MUST_BE_UNIQUE;

export const isEmailExistenceError = (error?: FieldError) => error?.type === SIGNUP_EMAIL_MUST_EXIST;
